import { useRef } from 'react';
import TargetsInfiniteList from './targetsInfiniteList';
import FilterListTargets from '../utils/filterLists/filterListTargets';
import ListPageLayout from '../utils/ListPageLayout';

function TargetsPage() {
  const updateQueryFunc = useRef(null);

  function handleQuery(filters) {
    if (typeof updateQueryFunc.current === 'function') {
      updateQueryFunc.current(filters);
    }
  }

  return (
    <>
      <ListPageLayout
        title="Targets"
        tagline="Maps, dates, and photographs of mission targets."
        sidebar={<FilterListTargets isFiltered={handleQuery} />}
      >
        <TargetsInfiniteList filterQuery={updateQueryFunc} />
      </ListPageLayout>
    </>
  );
}

export default TargetsPage;
